import { PropsWithChildren } from 'react';
import { Button } from '@/shadcn/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shadcn/tooltip';
import { cn } from '@/shadcn/lib/utils';

type GenericButtonProps = PropsWithChildren<{
  tooltipContent: string;
  onClick: () => void;
  disabled?: boolean;
  isActive?: boolean;
}>;

export const ToolbarButton = ({
  disabled = false,
  children,
  onClick,
  tooltipContent,
  isActive = false
}: GenericButtonProps) => (
  <Tooltip>
    <TooltipTrigger disabled={disabled} asChild>
      <Button
        disabled={disabled}
        size="smallIcon"
        type="button"
        variant="outline"
        onMouseDown={event => {
          event.preventDefault();
          onClick();
        }}
        className={cn(isActive && 'bg-accent')}
      >
        {children}
      </Button>
    </TooltipTrigger>
    <TooltipContent>{tooltipContent}</TooltipContent>
  </Tooltip>
);

ToolbarButton.displayName = 'ToolbarButton';
